import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axiosInstance from "services/AxiosInstance";
import { handleErrors } from "jsx/components/CitoPlus/components/ErrorHandlingComponent";

const PreRegistroVisitantesModal = ({ show, onHide, slug }) => {
  const [detailData, setDetailData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (slug && show) {
      fetchDetail();
    }
  }, [slug, show]);

  const fetchDetail = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `/api/v3/visitantes/pre-registro/admin/${slug}/`,
      );
      setDetailData(response.data);
    } catch (error) {
      handleErrors(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Detalles del Pre Registro</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <p>Cargando...</p>
          </div>
        ) : detailData ? (
          <div>
            <div className="row mb-3">
              <div className="col-md-6">
                <h5 className="text-primary">Información Personal</h5>
                <p>
                  <strong>Nombres:</strong> {detailData.nombres || "N/A"}
                </p>
                <p>
                  <strong>Cédula:</strong> {detailData.cedula || "N/A"}
                </p>
                <p>
                  <strong>Celular:</strong> {detailData.celular || "N/A"}
                </p>
                <p>
                  <strong>WhatsApp:</strong> {detailData.whatsapp || "N/A"}
                </p>
                <p>
                  <strong>Correo:</strong> {detailData.correo || "N/A"}
                </p>
                <p>
                  <strong>Autorizado Por:</strong>{" "}
                  {detailData.autorizado_por || "N/A"}
                </p>
              </div>
              <div className="col-md-6">
                <h5 className="text-primary">Detalles del Registro</h5>
                <p>
                  <strong>Fecha Inicio:</strong>{" "}
                  {detailData.fecha_inicio || "N/A"}
                </p>
                <p>
                  <strong>Fecha Final:</strong>{" "}
                  {detailData.fecha_final || "N/A"}
                </p>
                <p>
                  <strong>Placa:</strong> {detailData.placa || "N/A"}
                </p>
                <p>
                  <strong>Nota:</strong> {detailData.nota || "N/A"}
                </p>
                <p>
                  <strong>Estado:</strong>{" "}
                  <span
                    className={`badge ${detailData.is_active ? "bg-success" : "bg-danger"}`}
                  >
                    {detailData.is_active ? "Activo" : "Inactivo"}
                  </span>
                </p>
                <p>
                  <strong>Inmueble:</strong> {detailData.inmueble || "N/A"}
                </p>
                <p>
                  <strong>Access Link:</strong>{" "}
                  {detailData.access_link || "N/A"}
                </p>
                <p>
                  <strong>Es Airbnb:</strong>{" "}
                  <span
                    className={`badge ${detailData.es_airbnb ? "bg-info" : "bg-secondary"}`}
                  >
                    {detailData.es_airbnb ? "Sí" : "No"}
                  </span>
                </p>
                <p>
                  <strong>Tipo de Ingreso:</strong>{" "}
                  {detailData.tipo_de_ingreso || "N/A"}
                </p>
                <p>
                  <strong>Creado:</strong> {detailData.created_at || "N/A"}
                </p>
                <p>
                  <strong>Actualizado:</strong> {detailData.updated_at || "N/A"}
                </p>
              </div>
            </div>
            {detailData.acompanantes && detailData.acompanantes.length > 0 && (
              <div className="mb-3">
                <h5 className="text-primary">Acompañantes</h5>
                <ul className="list-group">
                  {detailData.acompanantes.map((acompanante, index) => (
                    <li key={index} className="list-group-item">
                      <strong>{acompanante.nombres}</strong> -{" "}
                      {acompanante.cedula}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {detailData.factura_electronica &&
              Object.keys(detailData.factura_electronica).length > 0 && (
                <div className="mb-3">
                  <h5 className="text-primary">Factura Electrónica</h5>
                  <ul className="list-group">
                    {Object.entries(detailData.factura_electronica).map(
                      ([key, value]) => (
                        <li key={key} className="list-group-item">
                          <strong>{key}:</strong> {value || "N/A"}
                        </li>
                      ),
                    )}
                  </ul>
                </div>
              )}
            <div className="row">
              {detailData.firma && (
                <div className="col-md-4 mb-3">
                  <h6>Firma</h6>
                  <img
                    src={detailData.firma}
                    alt="Firma"
                    className="img-fluid rounded"
                  />
                </div>
              )}
              {detailData.adjunto && (
                <div className="col-md-4 mb-3">
                  <h6>Adjunto</h6>
                  {detailData.adjunto.includes(".pdf") ? (
                    <a
                      href={detailData.adjunto}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-primary"
                    >
                      Ver PDF
                    </a>
                  ) : (
                    <img
                      src={detailData.adjunto}
                      alt="Adjunto"
                      className="img-fluid rounded"
                    />
                  )}
                </div>
              )}
              {detailData.code_qr && (
                <div className="col-md-4 mb-3">
                  <h6>Código QR</h6>
                  <img
                    src={detailData.code_qr}
                    alt="Código QR"
                    className="img-fluid rounded"
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="text-center">
            <p>No hay datos disponibles.</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PreRegistroVisitantesModal;
